// extracted by mini-css-extract-plugin
export default {"container":"content-type-card_container__i8RTZ","icon":"content-type-card_icon__sQfZn","label":"content-type-card_label__XiBA+"};